import { observable, action, decorate } from 'mobx';
import Ajax from '../ajax/ajax';
import { emptyGuid, eventBusMessages, eventTypesForBus } from '../helper/enums';
import EventBus from '../helper/event.bus';

export class PermissionGroupsStore {

    constructor(rootStore) {
        this.rootStore = rootStore;
    }

    allPermissionGroups = [];

    currentSelectedPg = undefined;

    allAccounts = [];

    relatedPermissionGroupsForGraph = [];

    graphNodes = [];

    permissionGroupsPerRole = [];

    get getAllPermissionGroups() { return this.allPermissionGroups }

    get getAllAccounts() { return this.allAccounts }

    setPermissionGroupsPerRole = (val) => this.permissionGroupsPerRole = val;

    setAllPermissionGroups = (permissionGroups) => this.allPermissionGroups = permissionGroups;

    setCurrentSelectedPg = (pg) => this.currentSelectedPg = pg;

    setAllAccounts = (accounts) => this.allAccounts = accounts;

    setRelatedPermissionGroups = (permissionGroups) => this.relatedPermissionGroupsForGraph = permissionGroups;

    setGraphNodes = (nodes) => this.graphNodes = nodes;

    getPermissionGroups = () => Ajax.getAllPGs(this.getPermissionGroupsSuccess, this.getPermissionGroupsError);

    getPermissionGroupsSuccess = (response) => {
        this.setAllPermissionGroups(response.data);
        this.setAllAccounts([...new Set(response.data.map(x => x.accountName))]);
    }

    getPermissionGroupsError = (error) => console.log(error);

    getPermissionGroupsPerRole = (id) => Ajax.getPermissionGroupsPerRole(id, this.getPermissionGroupsPerRoleSuccess, this.getPermissionGroupsPerRoleError);

    getPermissionGroupsPerRoleSuccess = (response) => this.setPermissionGroupsPerRole(response.data);

    getPermissionGroupsPerRoleError = (error) => console.log(error);

    getRelatedPermissionGroups = (id) => Ajax.getRelatedPermissionGroups(id, this.getRelatedPermissionGroupsSuccess, this.getRelatedPermissionGroupsError);

    getRelatedPermissionGroupsSuccess = (response) => {
        let data = [];
        let nodes = [];
        if (response.data.length > 0) {
            data = response.data.map(({ permissionGroupID, permissionGroupParentID }) => (
                {
                    source: permissionGroupParentID,
                    target: permissionGroupID
                }));
            for (let i = 0; i < response.data.length; i++) {
                if (!nodes.find(e => e.id === response.data[i].permissionGroupID)) {
                    nodes.push({
                        id: response.data[i].permissionGroupID,
                        label: response.data[i].permissionGroupName
                    });
                }
                if (!nodes.find(e => e.id === response.data[i].permissionGroupParentID)) {
                    nodes.push({
                        id: response.data[i].permissionGroupParentID,
                        label: response.data[i].permissionGroupParentName
                    });
                }
            }
        } else {
            let currentPgName = localStorage.getItem('pgName');
            nodes.push({
                id: localStorage.getItem('pgID'),
                label: currentPgName
            });
            data.push({
                source: localStorage.getItem('pgID'),
                target: localStorage.getItem('pgID')
            })
        }
        this.setGraphNodes(nodes);
        this.setRelatedPermissionGroups(data);
    }

    getRelatedPermissionGroupsError = (error) => console.log(error);

    updatePgOwner = (data) => Ajax.updatePgOwner(data, this.updatePgOwnerSuccess, this.updatePgOwnerError);

    updatePgOwnerSuccess = (response) => {
        let newOwner = this.rootStore.peopleStore.allPeople.find(x => x.id === response.data);
        if (newOwner !== undefined) {
            this.currentSelectedPg.ownerName = newOwner.fullName;
        }
        this.rootStore.rolesStore.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.ownerChange, eventBusMessages.ownerChangeSucess);
    }

    updatePgOwnerError = (error) => {
        this.rootStore.rolesStore.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.unexpectedError);
    }
}
decorate(PermissionGroupsStore, {
    allPermissionGroups: observable,
    currentSelectedPg: observable,
    graphNodes: observable,
    relatedPermissionGroupsForGraph: observable,
    allAccounts: observable,
    permissionGroupsPerRole: observable,
    setPermissionGroupsPerRole: action,
    setAllAccounts: action,
    setCurrentSelectedPg: action,
    setAllPermissionGroups: action,
    setRelatedPermissionGroups: action,
    setGraphNodes: action
})